import type { FC, SVGProps } from 'react';

export const SmartleadLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
      fill="#7C3AED"
    />
    <path d="M8 7l4 3 4-3v2.5l-4 3-4-3V7z" fill="white" />
    <path d="M8 11l4 3 4-3v2.5l-4 3-4-3V11z" fill="white" opacity="0.7" />
    <path d="M8 15l4 3 4-3v2l-4 2-4-2v-2z" fill="white" opacity="0.5" />
  </svg>
);
